module.exports = __webpack_public_path__ + "img/flag_cn.9224d6e9.jpg";